export const GET_CLIENTS = 'api/clients';
export const GET_CLIENT_BY_UUID = 'api/clients/{uuid}';
export const CREATE_CLIENT = 'api/clients/create/';
export const UPDATE_CLIENT = 'api/clients/{uuid}/update/';
export const DELETE_CLIENT = 'api/clients/{uuid}/delete/';
export const GET_PROJECTS_BY_CLIENT = 'api/clients/{uuid}/projects';